module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/advertisement/advertisement.component.css
// module id = 958
// module chunks = 1